import { AxiosResponse } from 'axios';
import AxiosInstance from './AxiosInstance';

export const getAgentInfo = async (rid: string, token: string): Promise<AxiosResponse> =>
  AxiosInstance.get(`livechat/agent.info/${rid}/${token}`);
